export enum EnumTpAmb {
    Producao = 1,
    Homologacao = 2,
}